// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2505":"29ce4ee0","2980":"748219b0","3976":"b93ca17a","4274":"146b9a63","4347":"e2d71131","7780":"146b9a63","8239":"146b9a63"}[chunkId] + ".chunk.css";
};